import React, { useEffect, useState } from 'react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    d: 5,
    h: 19,
    m: 9,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          d,
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;else {
              h = 23;
              if (d > 0) d--;
            }
          }
        }
        return {
          d,
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-brand-deepInk py-18 px-6 text-center" data-id="element-132">
      <div className="max-w-[960px] mx-auto" data-id="element-133">
        <h2 className="font-display text-[26px] sm:text-[4vw] md:text-[44px] text-white mb-3 uppercase" data-id="element-134">
          El próximo lunes puede ser diferente
        </h2>
        <p className="text-[16px] text-brand-muted mb-7" data-id="element-135">
          Entrá al MegaPack Cuerpo Nuevo después de los 40 y empezá tu
          transformación hoy.
        </p>

        <p className="text-[12px] text-brand-red font-bold tracking-[1px] uppercase mb-2.5" data-id="element-136">
          ⚠️ Precio de lanzamiento — cierra en:
        </p>

        <div className="flex justify-center items-center gap-1.5 mb-6" data-id="element-137">
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-138">
            {pad(timeLeft.d)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-139">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-140">
            {pad(timeLeft.h)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-141">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-142">
            {pad(timeLeft.m)}
          </div>
          <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-143">
            :
          </span>
          <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-144">
            {pad(timeLeft.s)}
          </div>
        </div>

        <div className="flex flex-col gap-3 max-w-[560px] mx-auto mb-7" data-id="element-145">
          <div className="bg-white/5 border border-brand-border rounded-xl py-4.5 px-5 flex items-center justify-between gap-3 flex-wrap" data-id="element-146">
            <div className="text-left" data-id="element-147">
              <p className="font-display text-[14px] text-white mb-0.5 uppercase" data-id="element-148">
                📦 MegaPack Cuerpo Nuevo después de los 40
              </p>
              <p className="text-[12px] text-brand-muted" data-id="element-149">6 Tomos + 6 Bonos</p>
            </div>
            <div className="text-right" data-id="element-150">
              <span className="text-[12px] text-[#555] line-through block" data-id="element-151">
                $51.000
              </span>
              <span className="font-display text-[20px] font-bold text-brand-green" data-id="element-152">
                $19.990 ARS
              </span>
            </div>
          </div>

          <div className="bg-brand-green/5 border-2 border-brand-green rounded-xl py-4.5 px-5 flex items-center justify-between gap-3 flex-wrap" data-id="element-153">
            <div className="text-left" data-id="element-154">
              <p className="font-display text-[14px] text-white mb-0.5 uppercase" data-id="element-155">
                👑 MegaPack + Quema x2
              </p>
              <p className="text-[12px] text-brand-muted" data-id="element-156">
                6 Tomos + 6 Bonos + Plan 21 Días
              </p>
            </div>
            <div className="text-right" data-id="element-157">
              <span className="text-[12px] text-[#555] line-through block" data-id="element-158">
                $69.000
              </span>
              <span className="font-display text-[20px] font-bold text-brand-green" data-id="element-159">
                $27.990 ARS
              </span>
            </div>
          </div>
        </div>

        <a href="#checkout-quema-x2" className="block w-full max-w-[560px] mx-auto bg-brand-green text-white font-display text-[17px] font-bold tracking-[1px] py-4 px-7 rounded-lg text-center uppercase border-none cursor-pointer transition-transform hover:-translate-y-0.5 mb-3 shadow-[0_0_20px_rgba(0,200,83,0.2)]" data-id="element-160">
          🔥 QUIERO EL MEGAPACK + QUEMA X2
        </a>
        <a href="#checkout-megapack" className="block w-full max-w-[560px] mx-auto bg-transparent border-2 border-brand-green text-brand-green font-display text-[17px] font-bold tracking-[1px] py-4 px-7 rounded-lg text-center uppercase cursor-pointer transition-transform hover:-translate-y-0.5" data-id="element-161">
          → QUIERO SOLO EL MEGAPACK — $19.990 ARS
        </a>
      </div>
    </div>;
}